import React, { useMemo } from "react";
import DataTable from "../../../Components/Table";
import AutomatedPaymentToggle from "./AutomatedPaymentToggle";
import { isDisplayableAutomatedBillValue } from "./automatedBillsUtils";

function renderDisplayableValue(value) {
  return isDisplayableAutomatedBillValue(value) ? value : null;
}

export default function AutomatedBillsTable({
  bills = [],
  loading = false,
  loadingMap = {},
  onToggle,
}) {
  const columns = useMemo(
    () => [
      {
        header: "Provider",
        accessor: "providerName",
        cell: ({ row }) => (
          <div className="bills-page__automation-provider bills-page__automation-provider--table d-flex align-items-center gap-3">
            <div className="bills-page__automation-badge">
              {row.providerImage ? (
                <img src={row.providerImage} alt={row.providerName || "Provider"} />
              ) : (
                <span>{String(row.providerName || "BP").slice(0, 2).toUpperCase()}</span>
              )}
            </div>
            <div className="bills-page__automation-copy">
              <h3>{row.providerName}</h3>
            </div>
          </div>
        ),
      },
      {
        header: "Phone Number",
        accessor: "mobileNumber",
        cell: ({ value }) => renderDisplayableValue(value),
      },
      {
        header: "Amount",
        accessor: "amount",
        kind: "amount",
        cell: ({ value }) => (
          isDisplayableAutomatedBillValue(value) ? (
            <strong className="bills-page__table-amount">{value}</strong>
          ) : null
        ),
      },
      {
        header: "Frequency",
        accessor: "frequency",
        cell: ({ value }) => renderDisplayableValue(value),
      },
      {
        header: "Next Payment",
        accessor: "nextPaymentDate",
        cell: ({ value }) => renderDisplayableValue(value),
      },
      {
        header: "Status",
        accessor: "status",
        kind: "status",
        cell: ({ value }) => (
          <span className="bills-page__status-wrap">
            <span className={`bills-page__status-pill is-${String(value).toLowerCase()}`}>
              {value}
            </span>
          </span>
        ),
      },
      {
        header: "Automated Payment",
        id: "toggle",
        kind: "action",
        cell: ({ row }) => (
          isDisplayableAutomatedBillValue(row.mobileNumber) ? (
            <AutomatedPaymentToggle
              checked={row.isChecked}
              disabled={Boolean(loadingMap[row.id])}
              onClick={() => onToggle?.(row, !row.isChecked)}
            />
          ) : null
        ),
      },
    ],
    [loadingMap, onToggle],
  );

  return (
    <div className="bills-page__automation-table">
      <DataTable
        columns={columns}
        data={bills}
        emptyMessage="No automated bills available right now."
        loading={loading}
        rowKey="id"
      />
    </div>
  );
}
